import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'
import { ImageWithSkeleton } from '@ynap/image'

const bem = new BEMHelper('SidebarHeader')

const SidebarHeader = ({ onClick, open, messages, totals, lineItems, totalQuantity }) => {
    const longerListOfItems = lineItems.length > 4

    const renderLineItem = ({ imageObject, quantity }, i) => {
        const showQuantity = quantity > 1

        return (
            <div className={bem('lineItemImage')} key={i}>
                <ImageWithSkeleton {...imageObject} imageSrcset={imageObject?.srcSet} computeAttributes={false} />
                {showQuantity && <div className={bem('lineItemQuantity')}>x{quantity}</div>}
            </div>
        )
    }

    const renderContent = () => {
        if (open) return <h1 className={bem('title')}>{messages?.orderReview?.sidebarTitle({ quantity: totalQuantity })}</h1>
        return (
            <div className={bem('sidebarClosed')}>
                <div className={bem('totalQuantity')}>{totalQuantity}</div>
                <div className={bem('sidebarImages', { longerListOfItems })}>
                    {lineItems.length ? (
                        lineItems.map(renderLineItem)
                    ) : (
                        <Skeleton count={4} className={bem('skeletonImages')} containerClassName={bem('skeletonContainer')} />
                    )}
                </div>
                <div className={bem('sidebarTotal')}>
                    <span className={bem('total')}>{messages?.totals.total()}</span>
                    <span className={bem('amountTotal', { skeleton: !lineItems.length })}>{totals?.total}</span>
                </div>
            </div>
        )
    }
    return (
        <div className={bem('headerWrapper', { active: open })} onClick={onClick}>
            <div className={bem('header', { details: !open })}>
                <span className={bem('arrowIcon', { active: open })} />
                {renderContent()}
            </div>
        </div>
    )
}

SidebarHeader.propTypes = {
    onClick: PropTypes.func,
    open: PropTypes.bool,
    lineItems: PropTypes.arrayOf(PropTypes.object),
    totals: PropTypes.shape({
        total: PropTypes.string.isRequired,
    }),
    messages: PropTypes.shape({
        orderReview: PropTypes.shape({
            sidebarTitle: PropTypes.func,
        }),
        totals: PropTypes.shape({
            total: PropTypes.func,
        }),
    }).isRequired,
}

export default SidebarHeader
